module.exports = __webpack_public_path__ + "static/img/unknown-user.afa7ebb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unknown-user.svg
// module id = 24
// module chunks = 2